import { render, staticRenderFns } from "./SettingDefault.vue?vue&type=template&id=476ef8b0"
import script from "./SettingDefault.vue?vue&type=script&lang=js"
export * from "./SettingDefault.vue?vue&type=script&lang=js"
import style0 from "./SettingDefault.vue?vue&type=style&index=0&id=476ef8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports